import { createSlice } from '@reduxjs/toolkit'

import { ImageName } from 'common/api/v1/types'
import type { GlobalState } from '../../store'
import { FileInfo, setImage, setImageToDelete, setDevMode } from '../actions/settingsActions'
import { logoutUser } from '../actions/userActions'

interface State {
  [ImageName.product]?: FileInfo
  [ImageName.serviceProvider]?: FileInfo
  [ImageName.favicon]?: FileInfo
  toDelete: {
    [ImageName.product]: boolean
    [ImageName.serviceProvider]: boolean
    [ImageName.favicon]: boolean
  }
  devMode: boolean
}
export const initialStateSettings: State = {
  toDelete: {
    [ImageName.product]: false,
    [ImageName.serviceProvider]: false,
    [ImageName.favicon]: false,
  },
  devMode: localStorage.getItem('dev-mode') === 'enabled',
}

const settingsSlice = createSlice({
  name: 'settings',
  initialState: initialStateSettings,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        setImage,
        (state, { payload: { name, file } }): State => ({
          ...state,
          [name]: file,
          toDelete: { ...state.toDelete, [name]: false },
        }),
      )
      .addCase(
        setImageToDelete,
        (state, { payload: name }): State => ({
          ...state,
          toDelete: { ...state.toDelete, [name]: true },
          [name]: undefined,
        }),
      )
      .addCase(logoutUser.fulfilled, (): State => initialStateSettings)
      .addCase(setDevMode, (state, { payload }): State => ({ ...state, devMode: payload }))
  },
})

export default settingsSlice.reducer

export const selectDevMode = (state: GlobalState) => state.settingsReducer.devMode
